import type { SmsTemplateSelection } from '../services/clientSmsService';

export interface MessageDraftState {
  text: string;
  revision: number;
  selections: SmsTemplateSelection[];
  sending: boolean;
  error: string | null;
}

/** Page-lifetime memory only. One session belongs to exactly one client.
 * Pending sends retain that session even when its composer is unmounted. */
export function createMessageDraft(text = '') {
  let state: MessageDraftState = { text, revision: 0, selections: [], sending: false, error: null };
  const listeners = new Set<() => void>();
  return {
    getSnapshot: () => state,
    subscribe: (listener: () => void) => {
      listeners.add(listener);
      return () => { listeners.delete(listener); };
    },
    update: (change: Partial<MessageDraftState> | ((previous: MessageDraftState) => Partial<MessageDraftState>)) => {
      const delta = typeof change === 'function' ? change(state) : change;
      const editsDraft = 'text' in delta || 'selections' in delta;
      state = { ...state, ...delta, revision: state.revision + (editsDraft ? 1 : 0) };
      listeners.forEach(listener => listener());
    },
  };
}
export type MessageDraftSession = ReturnType<typeof createMessageDraft>;
